<template>
<div class="heading text-center">
    <div class="vld-parent">
        <loading :active.sync="isLoading" loader= 'bars' 
        :can-cancel="true" 
        :on-cancel="onCancel"
        :is-full-page="fullPage"></loading>
    </div>
    <img class="dividerline" src="../assets/img/sep.png" alt="" />
    <h2>About HPCA</h2>
    <img class="dividerline" src="../assets/img/sep.png" alt="" />
    <ul style="text-align:left" v-for="(data, i) in headertext" :key="i+50">
        <li v-html="data"></li>
    </ul>
    <h3>Press Coverage : </h3>
    <img class="dividerline" src="../assets/img/sep.png" alt="" />

    <ul style="text-align:left" v-for="(data, i) in presscoverage" :key="i+100">
        <li v-html="data"></li>
    </ul>
    
    <h3>Press Release : </h3>
    <ul style="text-align:left" v-for="(data, i) in pressrelease" :key="i">
        <li v-html="data"></li>
    </ul>
</div>
</template>

<script>
//import Radialmenucontainer from '@/components/sections/Radialmenucontainer'
import axios from 'axios'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: 'About',
    components: {
    //Radialmenucontainer,
    Loading
  },
    data () {
      return {
        msg: 'About',
        isLoading: false,
        fullPage: true,
        info: null,
        headertext:null,
        presscoverage:null,
        pressrelease:null
    }
  },
  methods: {
      handleClick (item) {
      this.lastClicked = item;
      this.$emit("HomeDivVisibility", true);
      this.$router.push({name:item});
    },
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
  mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/abouts')
      .then(response => {
        this.info = response.data
        this.headertext=this.info[0].aboutstatements
        this.presscoverage=this.info[0].presscoverage
        this.pressrelease=this.info[0].pressrelease
        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>



// WEBPACK FOOTER //
// src/components/About.vue